// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"501":"d89e83dda57e7e489ac6","940":"6a8e8a7873dcfe06cf91"}[chunkId] + ".css";
};